/**
 * 异常原因api
 * date:2022 04 13
 */
import httpRequest from '@/utils/request.js';

/**查询列表 */
export const exReasonList = (params = {}) => httpRequest.httpGet({
    url: '/service/exReason/page', params: {
        ...params
    }
})
/**添加*/
export const exReasonAdd = (data) => httpRequest.httpPost('/service/exReason/add', data)
/**修改*/
export const exReasonUpdate = (data) => httpRequest.httpPut('/service/exReason/update', data)
// /** 校验*/
// export const exReasonCheck = (data) => httpRequest.httpPost('/service/exReason/check', data)
/** 删除*/
export const exReasonsDel = (data) => httpRequest.httpdelete2('/service/exReason/del', data)

/**获取单条数据 */
export const exReasonDetail = (params = {}) => httpRequest.httpGet({
    url: '/service/exReason/detail', params: {
        ...params
    }
})
